import { render, staticRenderFns } from "./VehicleInspectionAssignments.vue?vue&type=template&id=2e62b3da&scoped=true&"
import script from "./VehicleInspectionAssignments.vue?vue&type=script&lang=ts&"
export * from "./VehicleInspectionAssignments.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleInspectionAssignments.vue?vue&type=style&index=0&id=2e62b3da&scoped=true&lang=scss&"
import style1 from "./VehicleInspectionAssignments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e62b3da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDatePicker,VIcon,VMenu,VSpacer,VTextField,VToolbar,VToolbarTitle})
